import { skipToken, useQuery } from "@tanstack/react-query";

import { edictsApi } from "@/api";
import { QueryKey } from "@/query/Query";

// The register's answer for one entry does not change while the search run it belongs to is on screen,
// so reopening the same overlay is served from the cache instead of calling the register again.
const EDICT_DOCUMENT_CACHE_TIME_MS = 15 * 60 * 1000;

/**
 * Fetches the detail fields the insolvency-edict register keeps in its per-entry document rather than in
 * the period listing. Only started once the overlay is open, so a search run stays one call per register.
 */
export function useEdictDocumentQuery(sourceReference: string | null) {
  return useQuery({
    queryKey: [QueryKey.EdictDocument, sourceReference],
    queryFn: sourceReference === null ? skipToken : () => edictsApi.getEdictDocument({ sourceReference }),
    // The register call is slow and the staff member can simply reopen the entry; retrying would only
    // multiply the wait before the failure reaches them.
    retry: false,
    staleTime: Infinity,
    gcTime: EDICT_DOCUMENT_CACHE_TIME_MS,
  });
}
